import { TProfileType } from '../../types/global/helper';

export const ETHNICITIES = [
    'african',
    'african american',
    'arab',
    'ashkenazi jewish',
    'bengali',
    'berber',
    'caribbean',
    'chinese',
    'creole',
    'dravidian',
    'dutch',
    'english',
    'filipino',
    'french',
    'german',
    'greek',
    'haitian',
    'han chinese',
    'hispanic',
    'igbo',
    'ibibio',
    'efik',
    'indian',
    'indigenous australian',
    'indigenous american',
    'irish',
    'italian',
    'japanese',
    'jewish',
    'korean',
    'latin american',
    'maasai',
    'malay',
    'mestizo',
    'middle eastern',
    'mongolian',
    'native hawaiian',
    'nepali',
    'nordic',
    'pashtun',
    'persian',
    'polynesian',
    'portuguese',
    'punjabi',
    'romani',
    'russian',
    'scottish',
    'slavic',
    'somali',
    'south asian',
    'southeast asian',
    'spanish',
    'swahili',
    'thai',
    'tibetan',
    'turkish',
    'uighur',
    'ukrainian',
    'vietnamese',
    'yoruba',
] as const;

export const LANGUAGES = [
    '!kung',
    'aari',
    'adja',
    'afar',
    'afrikaans',
    'akan',
    'albanian',
    'amharic',
    'antandroy',
    'anyin',
    'anyuak',
    'arabic',
    'armenian',
    'azerbaijani',
    'bambara',
    'banna',
    'bara',
    'bariba',
    'beja',
    'bengali',
    'berta',
    'bete',
    'betsimisaraka',
    'bini',
    'bissa',
    'bosnian',
    'bulgarian',
    'burmese',
    'cantonese',
    'cape verdean creole',
    'catalan',
    'cebuano',
    'chadian arabic',
    'chagossian creole',
    'chewa',
    'chichewa',
    'chiga',
    'chinese',
    'chokwe',
    'comorian (shikomor)',
    'croatian',
    'czech',
    'dagbani',
    'dagomba',
    'daju',
    'danish',
    'dinka',
    'diola',
    'dizi',
    'dogon',
    'dutch',
    'ebira',
    'edo',
    'efik',
    'egyptian arabic',
    'english',
    'embu',
    'esperanto',
    'estonian',
    'esan',
    'ewe',
    'fanti',
    'farsi',
    'finnish',
    'fon',
    'french',
    'fula',
    'fulfulde',
    'fur',
    'ga',
    'ganda (luganda)',
    'gamo',
    'gbagyi',
    'gbaya',
    'georgian',
    'german',
    'german (namibia)',
    'goffa',
    'grebo',
    'greek',
    'guarani',
    'gujarati',
    'gun',
    'gurage',
    'hausa',
    'hebrew',
    'hehe',
    'hindi',
    'hmong',
    'hungarian',
    'icelandic',
    'idoma',
    'igbo',
    'ijaw',
    'indonesian',
    'ingessana',
    'irish',
    'isan',
    'italian',
    'japanese',
    'javanese',
    'jola',
    'jukun',
    'kabyle',
    'kalenjin',
    'kanembu',
    'kanuri',
    'kamba',
    'kambata',
    'kikongo',
    'kikuyu',
    'kinyarwanda',
    'kiribati creole (in diaspora)',
    'kirundi',
    'kissi',
    'kongo',
    'konso',
    'korean',
    'krio',
    'kru',
    'kurdish',
    'kuteb',
    'kwanyama',
    'lao',
    'latin',
    'latvian',
    'lingala',
    'lithuanian',
    'luba-kasai',
    'luba-katanga',
    'luo',
    'luo (kenya)',
    'luxembourgish',
    'luvale',
    'macedonian',
    'maghrebi arabic',
    'makonde',
    'makua',
    'malagasy',
    'malay',
    'malayalam',
    'maltese',
    'mandinka',
    'maori',
    'marathi',
    'masalit',
    'maasai',
    'mbunda',
    'mende',
    'merina',
    'meru',
    'moba',
    'moro',
    'mongo',
    'mongolian',
    'moroccan arabic',
    'mossi',
    'mru',
    'mumuye',
    'myanmar',
    'nama',
    'naro',
    'ndonga',
    'nepali',
    'ngas',
    'ngbandi',
    'ngindo',
    'ngoni',
    'nuer',
    'nupe',
    'nyamwezi',
    'nyankole',
    'oriya',
    'ovambo',
    'ovimbundu',
    'pakistani punjabi',
    'pashto',
    'papiamento (curaçao but afro ties)',
    'persian',
    'pidgin',
    'pokot',
    'polish',
    'portuguese',
    'pulaar',
    'punjabi',
    'romanian',
    'russian',
    'safwa',
    'sakalava',
    'samoan',
    'sango',
    'sanskrit',
    'sara',
    'sawi',
    'sawahili',
    'sayo',
    'serbian',
    'serer',
    'setswana',
    'seychellois creole',
    'shilluk',
    'shimaore',
    'shindzuani',
    'shingazidja',
    'shona',
    'shua',
    'shilha',
    'sidamo',
    'sindhi',
    'sinhala',
    'siwi',
    'slovak',
    'slovenian',
    'soga',
    'songhai',
    'somali',
    'soninke',
    'spanish',
    'sukuma',
    'sundanese',
    'swahili',
    'swati',
    'swedish',
    'tachelhit',
    'tama',
    'tamil',
    'tarok',
    'tatar',
    'tegali',
    'telugu',
    'temne',
    'thai',
    'tigrinya',
    'tigre',
    'tsamakko',
    'tsonga',
    'tswana',
    'tumbuka',
    'tuareg',
    'turkana',
    'turkish',
    'twi',
    'ukrainian',
    'umbundu',
    'urdu',
    'urhobo',
    'uzbek',
    'vai',
    'venda',
    'vietnamese',
    'welsh',
    'wolaytta',
    'wolof',
    'xhosa',
    'yao',
    'yoruba',
    'zao',
    'zaghawa',
    'zande',
    'zulu',
] as const;

export const SKILLS = [
    'Accents/Dialects: American - General',
    'Accents/Dialects: English - Cockney',
    'Accents/Dialects: French (Parisienne)',
    'Accents/Dialects: Southern American',
    'Accents/Dialects: US South (Deep South, Dixie, Delta)',
    'Accents/Dialects: Various (RP, Cockney, Scottish, Irish, etc.)',
    'Acting',
    'Aerial Acrobatics (Fabrics/Silks)',
    'Aerialist: Lyra (Metal Hoop)',
    'Aerobatics (Plane Stunts)',
    'Airsoft Combat',
    'Animal Handling (Dogs, Cats, Horses, Birds, etc.)',
    'Archery Tag',
    'Archery',
    'Astrology Knowledge',
    'Athletic',
    'Audiobooks',
    'Balloon Animal Making',
    'Ballroom Dancing',
    'Bartender',
    'Basic First Aid',
    'Beat Matching',
    'Beatboxing',
    'Beer Brewing',
    'Blacksmithing',
    'BMX',
    'Boating/Sailing',
    'Body Double Experience',
    'Boomerang Throwing',
    'Breakdancing',
    'Bull Riding',
    'Calligraphy',
    'Camera/Videography',
    'Candle Making',
    'Canoeing/Kayaking',
    'Car Mechanics',
    'Carpentry',
    'Cartoon Voice Acting',
    'Cheerleading',
    'Clown Performance',
    'Comedy',
    'Compositional Sketch Artist',
    'Content Creation',
    'Cooking',
    'CPR Certified',
    'Cycling',
    'Dance: Bachata',
    'Dance: Ballet',
    'Dance: Choreography',
    'Dance: Commercial',
    'Dance: Contact Improvisation',
    'Dance: Freestyle/Improvisation',
    'Dance: Hip Hop',
    'Dance: Jazz',
    'Dance: Modern',
    'Dance: Movement',
    'Dance: Roller Dance',
    'Dance: Street Dance',
    'Dance: Tap',
    'Directing',
    'Diving',
    'DJing',
    'Drama Training',
    'Dramatic Monologues',
    'Driving Stick Shift',
    'Drone Piloting',
    'Editing',
    'Embroidery',
    'Equestrian (Dressage)',
    'Escape Artist Tricks',
    'Escape Room Mastery',
    'Escape Room Skills',
    'Etiquette Coaching',
    'Explosives Handling (Stage/Film Only)',
    'Face Painting',
    'Falconry',
    'Farm Work',
    'Fast Typing',
    'Fencing (Modern and Historical)',
    'Fencing',
    'Fight Choreography',
    'Fine Arts: Drawing',
    'Fine Arts: Painting',
    'Fine Arts: Sculpture',
    'Fire Dancing',
    'Fire Eating',
    'Firearms Handling',
    'Fishing',
    'Forensic Science Knowledge',
    'Freediving',
    'Gaming (Esports)',
    'Ghost Hunting Experience',
    'Glass Blowing',
    'Goat Yoga',
    'Gospel Singing',
    'Gymnastics',
    'Hair Styling',
    'Hand Balancing',
    'Handwriting Analysis',
    'Helicopter Piloting',
    'High Diving',
    'Hiking',
    'Historical Reenactment',
    'Horseback Archery',
    'Horseback Riding',
    'Hosting/Presenting',
    'Hot Air Balloon Piloting',
    'How-to Videos',
    'Hula Hooping',
    'Hunting',
    'Hyper-Realistic Crying on Cue',
    'Ice Skating',
    'Impersonations',
    'Improvisation',
    'International Traveler',
    'Jewelry Making',
    'Juggling',
    'Knife Throwing',
    'Knitting/Crocheting',
    'Knot Tying',
    'Krav Maga',
    'Languages: French',
    'Languages: Spanish',
    'LARPing (Live Action Role Play)',
    'Laser Tag',
    'Leatherworking',
    'Lifeguard (Red Cross Card)',
    'Lip Reading',
    'Lip Synch / ADR',
    'Magic Tricks',
    'Makeup Artistry',
    'Martial Arts',
    'Meat Butchering',
    'Mechanical Skills',
    'Meisner Technique',
    'Meteorology Basics',
    'Method Acting',
    'Military Drills',
    'Mime',
    'Modeling: Beauty & Makeup Modeling',
    'Modeling: Commercial Modeling',
    'Modeling: Fit Modeling',
    'Modeling: Full Figure Modeling',
    'Modeling: Lifestyle & Editorial Modeling',
    'Modeling: Print & Digital Modeling',
    'Modeling: Swimsuit & Lingerie Modeling',
    'Motorcycle Riding',
    'Mountain Biking',
    'Music Composition',
    'Music Producing',
    'Music Sight Reading',
    'Music/Musician: Cello',
    'Music/Musician: Drums/Percussion',
    'Music/Musician: Guitar',
    'Music/Musician: Piano/Keyboards',
    'Musical Style: Experimental',
    'Musical Style: Jazz',
    'Musical Theater',
    'Navigational Skills (Compass & Stars)',
    'Opera Singing',
    'Origami',
    'Paragliding',
    'Parkour',
    'Personal Trainer',
    'Physical Theater',
    'Pilates',
    'Poi Spinning',
    'Police Procedures Knowledge',
    'Production/Crew: Camera/Videography',
    'Production/Crew: Costume Design',
    'Production/Crew: Directing',
    'Production/Crew: Editing',
    'Production/Crew: Fight Choreography',
    'Production/Crew',
    'Public Speaking',
    'Puppeteering',
    'Quick Costume Changes',
    'Racing (Go-Kart, Dirt Bikes)',
    'Racquetball',
    'Rally Car Racing',
    'Rappelling',
    'Rapping',
    'Rock Climbing',
    'Rollerblading',
    'Rope Climbing',
    'Running in Heels',
    'Running',
    'Screen Acting',
    'Scuba Diving',
    'Shadow Puppetry',
    'Shooting',
    'Sign Language',
    'Silent Acting (Pantomime)',
    'Singing: Adult Contemporary',
    'Singing: Jazz/Blues',
    'Singing: Mezzo Soprano',
    'Singing: Musical Theatre',
    'Singing: Pop/Rock',
    'Singing: Sight Singing',
    'Singing',
    'Sketch Artist',
    'Sketch Comedy',
    'Skiing',
    'Skydiving',
    'Slacklining',
    'Snowboarding',
    'Soccer',
    'Softball',
    'Songwriting',
    'Space & Astronomy Knowledge',
    'Speed Reading',
    'Splits',
    'Spy/Secret Agent Role Play',
    'Stage Acting',
    'Stage Combat',
    'Stand-up Comedy',
    'Stealth Movement',
    'Storytelling',
    'Stunts',
    'Surfing',
    'Survival Skills',
    'Swimming',
    'Swing Dancing',
    'Sword Dancing',
    'Sword Fighting',
    'Tactical Evasion Training',
    'Tai Chi',
    'Tarot Reading',
    'Tattoo Art',
    'Tattoo Designing',
    'Teleprompter / Autocue',
    'Tennis',
    'Testimonials / Reviews',
    'Tightrope Walking',
    'Tractor Driving',
    'Trampoline',
    'Trapeze',
    'Truck Driving',
    'Underwater Acting',
    'Unicycling',
    'User-Generated Content (UGC)',
    'Vegan Cooking',
    'Ventriloquism',
    'Voice Style: Articulate',
    'Voice Style: Awkward',
    'Voice Style: Calm',
    'Voice Style: Charismatic',
    'Voice Style: Confident',
    'Voice Style: Edgy',
    'Voice Style: Expressive',
    'Voice Style: Sad',
    'Voice Style: Serious',
    'Voice Style: Singing',
    'Voice Style: Snarky',
    'Voice Style: Soothing',
    'Voiceover',
    'Volleyball',
    'Wakeboarding',
    'Weapons Training',
    'Whip Cracking',
    'Whistling',
    'Winemaking',
    'Woodworking',
    'Writing: Screenwriting',
    'Yodeling',
    'Yoga',
] as const;

export type TEthinities = (typeof ETHNICITIES)[number];
export type TLanguage = (typeof LANGUAGES)[number];
export type TSkills = (typeof SKILLS)[number];

export const VOICE_SKILL = [
    'Voice Acting',
    'Character Voices',
    'Animation Voice Acting',
    'Video Game Voice Acting',
    'Commercial Voice Over',
    'Narration',
    'Audiobook Narration',
    'Podcast Narration',
    'Documentary Narration',
    'Corporate / E-Learning Voice Over',
    'Explainer Video Voice Over',
    'IVR / Telephone System Voice Over',
    'Dubbing',
    'ADR (Automated Dialogue Replacement)',
    'Lip-Sync Dubbing',
    'Impressions',
    'Accent Performance',
    'Dialect Performance',
    'Cartoon Voices',
    'Villain Voices',
    'Hero Voices',
    'Creature / Monster Voices',
    'Children’s Voices',
    'Teen Voices',
    'Senior Voices',
    'Singing Voice Acting',
    'Jingles',
    'Radio Drama',
    'Storytelling',
    'Spoken Word Performance',
    'Improvised Voice Acting',
    'Voice Acting for AR/VR',
    'Voice Acting for AI Assistants',
    'Vocal Warmups',
    'Breath Control',
    'Projection',
    'Pitch Control',
    'Tone Control',
    'Vocal Range Expansion',
    'Emotional Expression',
    'Timing & Pacing',
    'Comedy Timing',
    'Script Interpretation',
    'Cold Reading',
    'Voice Acting in Multiple Languages',
];

export const PERFORMER_SKILL = [
    'Acappella Performance',
    'Accent Training',
    'Acrobatics',
    'Acting',
    'Activist Art',
    'Aerial Dance',
    'Aerial Hoop',
    'AR/VR Performance',
    'Ballet',
    'Ballroom Dance',
    'Band Performance',
    'Beatboxing',
    'Belly Dance',
    'Bharatanatyam',
    'Body Art Performance',
    'Brass Instruments',
    'Breakdancing',
    'Burlesque',
    'Busking',
    'Capoeira',
    'Chanting',
    'Character Development',
    'Choir Singing',
    'Choreography',
    'Circus Arts',
    'Classical Acting',
    'Clowning',
    'Commercial Modeling',
    'Contact Improvisation',
    'Contemporary Dance',
    'Contortion',
    'Costume Performance',
    'Cultural Dance',
    'Cyr Wheel',
    'Dance Theatre Fusion',
    'Dance',
    'Debate Performance',
    'Devised Theatre',
    'Dialect Training',
    'DJing',
    'Drag Performance',
    'Drumming / Percussion',
    'Ensemble Acting',
    'Escape Artistry',
    'Experimental Theatre',
    'Fashion Modeling',
    'Fight Choreography',
    'Fire Performance',
    'Fitness Modeling',
    'Flamenco',
    'Flash Mob Choreography',
    'Folk Dance',
    'Freestyle Dance',
    'Gesture & Expression Training',
    'Gospel Singing',
    'Guitar Performance',
    'Hand Balancing',
    'Hip Hop Dance',
    'Hosting',
    'Human Pyramids',
    'Illusion',
    'Immersive Theatre',
    'Improvisation',
    'Improvised Comedy',
    'Instrumental Performance',
    'Interactive Performance',
    'Jazz Dance',
    'Jazz Vocals',
    'Juggling',
    'Kathak',
    'Knife Throwing',
    'Krumping',
    'Latin Dance',
    'Magic',
    'Mask Theatre',
    'Mask Work',
    'MC Skills',
    'Method Acting',
    'Mime',
    'Modeling',
    'Monologue Performance',
    'Movement Direction',
    'Multimedia Performance',
    'Music Performance',
    'Musical Theatre',
    'Narration',
    'Odissi',
    'Opera Singing',
    'Oratory',
    'Orchestral Performance',
    'Performance Installation Art',
    'Performance Poetry',
    'Physical Theatre',
    'Piano Performance',
    'Podcast Performance',
    'Pole Dance',
    'Pop Vocals',
    'Print Modeling',
    'Projection Performance',
    'Protest Performance',
    'Public Speaking',
    'Puppetry',
    'Radio Performance',
    'Rapping',
    'Rock Vocals',
    'Runway Modeling',
    'Salsa',
    'Screen Acting',
    'Shadow Play',
    'Shakespearean Acting',
    'Silks',
    'Singing',
    'Slackline',
    'Solo Singing',
    'Songwriting',
    'Spoken Word',
    'Stage Acting',
    'Stage Combat',
    'Stage Makeup',
    'Stage Management',
    'Stand-Up Comedy',
    'Stilt Walking',
    'Storytelling',
    'Street Theatre',
    'String Instruments',
    'Stunt Performance',
    'Swing',
    'Sword Fighting',
    'Tango',
    'Tap Dance',
    'Theatre Directing',
    'Throat Singing',
    'Tightrope Walking',
    'Traditional Dance',
    'Trapeze',
    'Ventriloquism',
    'Vocal Percussion',
    'Vogueing',
    'Voice Acting',
    'Waacking',
    'Wind Instruments',
    'Yodeling',
];

export const TECH_KILL = [
    '1st Assistant Camera (Focus Puller)',
    '2nd Assistant Camera (Clapper Loader)',
    'Accountant',
    'ADR Supervisor',
    'Animal Wrangler',
    'Armorer',
    'Art Director',
    'Assistant Art Director',
    'Assistant Costume Designer',
    'Assistant Editor',
    'Assistant Location Manager',
    'Assistant Makeup Artist',
    'Assistant Production Coordinator',
    'Barber',
    'Best Boy Electric',
    'Best Boy Grip',
    'Boom Operator',
    'BTS Photographer',
    'BTS Videographer',
    'Camera Operator',
    'Captioning Specialist',
    'Carpenter',
    'Caterer',
    'Catering Assistant',
    'Colorist',
    'Community Manager',
    'Composer',
    'Compositor',
    'Costume Designer',
    'Costumer',
    'COVID Compliance Officer',
    'Craft Services',
    'Digital Imaging Technician (DIT)',
    'Director of Photography',
    'Dolly Grip',
    'Dresser',
    'Driver',
    'Drone Operator',
    'Drone Pilot',
    'Editor',
    'Executive Producer',
    'Fight Choreographer',
    'Foley Artist',
    'Gaffer',
    'Greensman',
    'Grip',
    'Hair Stylist',
    'Intimacy Coordinator',
    'Key Grip',
    'Key Makeup Artist',
    'Lighting Technician',
    'Line Producer',
    'Live Stream Operator',
    'Location Manager',
    'Location Scout',
    'Medic',
    'Model Maker',
    'Motion Graphics Designer',
    'Music Editor',
    'Music Supervisor',
    'Painter',
    'Payroll Clerk',
    'Playback Operator',
    'Post Production Supervisor',
    'PR Liaison',
    'Precision Driver',
    'Producer',
    'Production Assistant',
    'Production Coordinator',
    'Production Designer',
    'Production Manager',
    'Production Secretary',
    'Production Sound Mixer',
    'Props Assistant',
    'Props Master',
    'Prosthetics Artist',
    'Publicist',
    'Pyrotechnician',
    'Re-Recording Mixer',
    'Rigger',
    'Rigging Gaffer',
    'Rigging Grip',
    'Scenic Artist',
    'Script Supervisor',
    'Seamstress',
    'Security',
    'Set Designer',
    'Set Dresser',
    'Set Nurse',
    'Social Media Content Producer',
    'Sound Assistant',
    'Sound Designer',
    'Special Effects Makeup Artist',
    'Special Effects Supervisor',
    'Special Effects Technician',
    'Standby Props',
    'Steadicam Operator',
    'Still Photographer',
    'Stunt Coordinator',
    'Stunt Performer',
    'Subtitling Specialist',
    'Tailor',
    'Textile Artist',
    'Transport Captain',
    'Underwater Camera Operator',
    'Unit Production Manager',
    'Utility Sound Technician',
    'Vehicle Coordinator',
    'VFX Artist',
    'Video Assist Operator',
    'Visual Effects Supervisor',
    'Wardrobe Supervisor',
    'Weapons Master',
];

export const CONTENT_CREATOR_SKILL = [
    'Video Production',
    '360 Video Content',
    'Activism Content',
    'Advocacy Content',
    'Affiliate Marketing',
    'Analytics & Insights',
    'Animation (2D/3D)',
    'AR Content Creation',
    'ASMR Content',
    'Audience Engagement',
    'Audio Editing',
    'Audio Recording',
    'Beauty Content',
    'Behind-the-Scenes Content',
    'Blogging',
    'Brand Collaboration',
    'Cinematography',
    'Clickbait Strategy',
    'Color Grading',
    'Comedy / Skit Content',
    'Community Management',
    'Content Distribution',
    'Content Planning',
    'Content Repurposing',
    'Content Scheduling',
    'Content Writing',
    'Cooking Shows',
    'Copywriting',
    'Creative Writing',
    'Dance Content',
    'Data-Driven Content',
    'Digital Painting',
    'Directing',
    'DIY / Maker Content',
    'Documentary Content',
    'Drone Filming',
    'Educational Content',
    'Email Marketing',
    'Event Coverage',
    'Fashion Content',
    'Filmmaking',
    'Fitness Content',
    'Food Content',
    'Gaming Live Streaming',
    'Graphic Design',
    'Growth Hacking',
    'Illustration',
    'Influencer Marketing',
    'Instagram Reels Content',
    'Interview Hosting',
    'Journalism',
    'Lifestyle Content',
    'Lighting for Video',
    'Live Streaming',
    'Makeup Tutorials',
    'Marketing Strategy',
    'Memes & Viral Content',
    'Mobile Content Creation',
    'Modeling Content',
    'Motion Graphics',
    'Motivational Speaking Content',
    'Music Content',
    'Newsletter Writing',
    'On-Camera Presentation',
    'Personal Branding',
    'Photo Editing',
    'Photography',
    'Platform Optimization (YouTube/Instagram/TikTok)',
    'Podcasting',
    'Product Demos',
    'Public Speaking',
    'Reaction Videos',
    'Review Content',
    'Screenwriting',
    'Scriptwriting',
    'SEO Writing',
    'Short Form Content Creation',
    'Social Media Management',
    'Social Media Strategy',
    'Sound Design',
    'Stop Motion',
    'Storyboarding',
    'Storytelling',
    'Tech Reviews',
    'Thumbnail Design',
    'TikTok Content Creation',
    'Travel Vlogging',
    'Tutorial / How-To Content',
    'UI/UX for Content Platforms',
    'Unboxing Content',
    'VFX (Visual Effects)',
    'Video Editing',
    'Vlogging',
    'Voice Over',
    'VR Content Creation',
    'Web Design',
    'YouTube Content Creation',
];

export const CORE_SKILLS: Record<TProfileType, string[]> = {
    voiceover: VOICE_SKILL,
    performer: PERFORMER_SKILL,
    content_creator: CONTENT_CREATOR_SKILL,
    technical: TECH_KILL,
    artist: PERFORMER_SKILL,
} as const;
